import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-2" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "ms-2 text-muted" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "mb-2 small"
};
const _hoisted_7 = {
    key: 0,
    class: "fw-bold"
};
const _hoisted_8 = {
    key: 2,
    class: "form-check mb-2"
};
const _hoisted_9 = {
    class: "form-check-label",
    for: "backgroundTaskOnlyNotDone"
};
const _hoisted_10 = { class: "table table-sm align-middle background-task-items-table" };
const _hoisted_11 = { class: "item-name" };
const _hoisted_12 = {
    key: 0,
    class: "small text-muted"
};
const _hoisted_13 = {
    key: 0,
    class: "small mt-1"
};
const _hoisted_14 = {
    key: 1,
    class: "mt-1"
};
const _hoisted_15 = { class: "text-danger fw-bold" };
const _hoisted_16 = {
    key: 0,
    class: "mb-0 small text-danger"
};
const _hoisted_17 = {
    key: 1,
    class: "support-reference mt-1"
};
const _hoisted_18 = {
    key: 2,
    class: "small text-muted mt-1"
};
const _hoisted_19 = {
    key: 3,
    class: "small text-muted mt-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        id: "background-task-details-modal",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.show) = $event)),
        title: _ctx.title,
        size: "xl",
        scrollable: "",
        "header-bg-variant": "normal"
    }, {
        footer: _withCtx(() => [
            (_ctx.failedItems.length)
                ? (_openBlock(), _createBlock(_component_b_button, {
                    key: 0,
                    type: "button",
                    variant: "outline-secondary",
                    onClick: _ctx.copyProblems
                }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fa fa-copy" }, null, -1 /* CACHED */),
                            _createTextVNode(" Copy problems for support\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true),
            _cache[20] || (_cache[20] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.show = false))
            }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("Close", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            })
        ]),
        default: _withCtx(() => {
            var _a;
            return [
                (_ctx.message)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, [
                            ((_a = _ctx.details) === null || _a === void 0 ? void 0 : _a.subtitle)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_ctx.details.subtitle), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.summary), 1 /* TEXT */)
                        ]),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        (_ctx.message.errorMessage)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(['alert', 'py-2', _ctx.alertClass])
                            }, [
                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-exclamation-circle me-1" }, null, -1 /* CACHED */)),
                                _createTextVNode(_toDisplayString(_ctx.message.errorMessage) + " ", 1 /* TEXT */),
                                (_ctx.failedItems.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "The reason is shown against each item below."))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        (!_ctx.isFinished && _ctx.message.stepDescription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_ctx.message.currentItem)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.message.currentItem) + ": ", 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(_toDisplayString(_ctx.message.stepDescription), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        (_ctx.notDoneItems.length && _ctx.items.length > _ctx.notDoneItems.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "backgroundTaskOnlyNotDone",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.onlyNotDone) = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelCheckbox, _ctx.onlyNotDone]
                                ]),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("label", _hoisted_9, "Show only items that were not done (" + _toDisplayString(_ctx.notDoneItems.length) + ")", 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createElementVNode("table", _hoisted_10, [
                            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Item"),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "Result")
                                ])
                            ], -1 /* CACHED */)),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item, index) => {
                                    var _a;
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: index,
                                        class: _normalizeClass(_ctx.rowClass(item))
                                    }, [
                                        _createElementVNode("td", _hoisted_11, [
                                            _createTextVNode(_toDisplayString(item.name) + " ", 1 /* TEXT */),
                                            (item.description)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.description), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(['badge', _ctx.statusBadge(item)])
                                            }, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(_ctx.statusIcon(item))
                                                }, null, 2 /* CLASS */),
                                                _createTextVNode(" " + _toDisplayString(_ctx.statusText(item)), 1 /* TEXT */)
                                            ], 2 /* CLASS */),
                                            _cache[10] || (_cache[10] = _createTextVNode()),
                                            (item.status === 'Succeeded')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                    _createTextVNode(_toDisplayString(item.summary) + " ", 1 /* TEXT */),
                                                    ((_a = item.link) === null || _a === void 0 ? void 0 : _a.url)
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 0,
                                                            to: item.link.url,
                                                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.show = false)),
                                                            class: "ms-1"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.link.text || "Open"), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : (item.status === 'Failed')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.message), 1 /* TEXT */),
                                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                                        (item.errors && item.errors.length)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.errors, (error, errorIndex) => {
                                                                    return (_openBlock(), _createElementBlock("li", { key: errorIndex }, _toDisplayString(error), 1 /* TEXT */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                                        (item.errorReference)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                                _cache[7] || (_cache[7] = _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tSupport reference: ", -1 /* CACHED */)),
                                                                _createElementVNode("code", null, _toDisplayString(item.errorReference), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]))
                                                    : (item.status === 'Cancelled')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.message), 1 /* TEXT */))
                                                        : (item.status === 'Pending' && _ctx.isFinished)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "\r\n\t\t\t\t\t\t\t\tNot done.\r\n\t\t\t\t\t\t\t"))
                                                            : _createCommentVNode("v-if", true)
                                        ])
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[21] || (_cache[21] = _createTextVNode())
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "title"]));
}
